<template>
   
  <div class="row">
    <div v-if="!loading && details" class="col-12 mb-5">
      <div class="row">
        <div class="col">
          <strong># {{ $t('default.evaluations.student') }}</strong>
        </div>
      </div>
      <div class="row my-2" :key="student.studentID" v-for="(student, $sIdx) of details.evaluations">
        <div class="col-12 col-md-6 col-lg-4">
          {{ $sIdx + 1 }}
          {{ $helpers.getLocalizedField(student, 'stud') }}
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <div class="row">
            <div :key="$eIdx" v-for="(evaluation, $eIdx) of student.evaluation" class="col"> 
              <input class="form-control" @blur="handleInput($sIdx, $eIdx, $event)" v-model="student.evaluation[$eIdx].point" :id="'forDisable_'+$sIdx+'_'+$eIdx" type="text" @focus="disableOthers($sIdx, $eIdx, details.evaluations,student.evaluation)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GroupQuizEvaluations',

  props: ['loading', 'details'],

  methods: {
    saveEvaluation (sIdx, eIdx) {
      this.$emit('save-evaluation', {
        type: 'quiz',
        studentId: this.details.evaluations[sIdx].studentID,
        rateComponentId: this.details.evaluations[sIdx].evaluation[eIdx].id,
        point: this.details.evaluations[sIdx].evaluation[eIdx].point
      })
    },

    handleInput (sIdx, eIdx, event) {
      this.saveEvaluation(sIdx, eIdx)
    },
    disableOthers(sIdx, eIdx, firstArray,secondSubArray){

      for(let i=0; i<firstArray.length; i++){

        for(let j=0; j<secondSubArray.length; j++)
        {

          if(i!=sIdx || j!=eIdx){

              document.getElementById('forDisable_'+i+'_'+j).setAttribute('disabled',true)

          }

        }

      }


    }
  }
}
</script>
